module.exports = __webpack_public_path__ + "static/media/EP-tausta.bb1675ca.jpg";